<template>
    <div class="bc-box">
        <div class="bc-header">
            <span class="bc-title">专属域名转换</span>
            <span class="bc-cont">
                <el-alert title="提示：输入需要转换的链接--------------------------选择专属域名--------------------------生成短连接" type="warning" :closable="false" show-icon></el-alert>
            </span>
        </div>
        <div class="bc-main box-sizing">
            <div class="m-left box-sizing">
                <div class="tit">原网址（每行一条）</div>
                <div class="mid">
                    <textarea v-model="orgUrl" class="box-sizing" placeholder="如：https://www.baidu.com/T5hp https://www.baidu.com/T5hp2"></textarea>
                </div>
                <div class="bot box-sizing">
                    <el-button class="bot-btn" type="danger" plain @click="clearAll">清空</el-button>
                    <div class="tips box-sizing">
                        <h5>温馨提示：</h5>
                        <div class="desc">
                            <p>若需添加备注，链接和备注之间用竖线“|”分隔开</p>
                            <p>例：https://www.ttdwz.cc/test1|测试连接1</p>
                            <p>https://www.ttdwz.cc/test2|测试连接2</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="m-mid box-sizing">
                <div class="flex-center flex-column item-center">
                    <div class="mb-10 pad">
                        <el-select v-model="value" filterable @change="get_se_domain($event)" clearable placeholder="请选择" :loading="isLoading" @visible-change="getDomainList" style="width:100px;">
                            <el-option v-for="item in options" :key="item.id" :label="item.domain" :value="item.id"></el-option>
                        </el-select>
                    </div>
                    <div class="flex-row item-center">
                        <span>字符</span>
                        <el-select  v-model="lx" class="mt10 ml10" style="width:110px;">
                            <el-option v-for="(item2,idx) in lxs" :label="item2" :value="idx"></el-option>
                        </el-select>

                    </div>
                    <div class="flex-row item-center">
                        <span>长度</span>
                        <el-select v-model="cd" class="mt10 ml10" style="width:90px;">
                            <el-option v-for="item2 in cds" :key="item2" :label="item2" :value="item2"></el-option>
                        </el-select>

                    </div>
                    <div v-if="cd==0" class="padtb red">
                        0代表域名直转
                    </div>

                    <div class="mt10"></div>
                    <div><el-button type="primary" @click="startZh">开始转换</el-button></div>
                </div>
            </div>
            <div class="m-right box-sizing">
                <div class="tit">短网址</div>
                <div class="mid">
                    <textarea v-model="newUrl" class="box-sizing" placeholder="生成的短网址" readonly></textarea>
                </div>
                <div class="bot box-sizing">
                    <el-button class="bot-btn" type="primary" plain @click="copyUrl">全部复制</el-button>
                    <div class="tips box-sizing">
                        <h5>温馨提示：</h5>
                        <div class="desc">
                            批量生成短链接对应的二维码，请到短网址列表获取 <br>
                            如果后缀重复，请自行去短网址列表进行修改,此处不判断重复


                        </div>

                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "ShortUrl",
        data() {
            return {
                orgUrl:"",
                newUrl:"",
                options: [],
                value: '',
                se_domain:'',
                isLoad: false,
                isLoading: true,
                isLoading2: true,
                cds:[0,1,2,3,4,5,6,7,8],
                cd:4,
                lxs:['字母+数字','字母','数字'],
                lx:0
            }
        },
        mounted() {
        },
        methods: {
            async getDomainList(val) {
                if (!val) return;
                if (this.isLoad) return;
                const {ret,msg,data} = await this.$api.exclusive.getUserList();
                if (ret === 1000){
                    this.isLoad = true;
                    this.isLoading = false;
                    this.options = data.list;
                }
            },
            async startZh() {
                if(this.cd==0){
                    this.saveIndexUrl();
                    return;
                }
                const id = this.value;
                const url = this.orgUrl;

                if (url === ''){
                    this.$message.error('请输入要转换的长链接!');
                    return;
                }

                if (id === ''){
                    this.$message.error('请选择专属域名!');
                    return;
                }

                const postData = {
                    id: id,
                    urlData: url,
                    changdu:this.cd,
                    str_type:this.lx
                };

                const {ret,msg,data} = await this.$api.exclusive.zh(postData);
                if (ret === 1000){
                    this.$message.success('转换成功');
                    this.newUrl = data.urls;
                }
            },
            copyUrl() {
                const msg = this.$message;
                if (this.newUrl === ''){
                    msg.error('复制的内容为空！');
                    return;
                }
                this.$copyText(this.newUrl).then(function (e) {
                    msg.success('复制成功');
                }, function (e) {
                    msg.error('复制失败！');
                })
            },
            clearAll() {
                this.orgUrl = "";
                this.newUrl = "";
                this.$message.success('清除成功！');
            },
            async saveIndexUrl() {
                if (!this.value) {
                    this.$message.error('请选择域名');
                    return;
                }
                this.isLoading2 = true;
                const postData = {
                    id: this.value,
                    index_url:  this.orgUrl,
                };
                const {ret} = await this.$api.exclusive.saveDomainIndexUrl(postData);
                if (ret === 1000){
                    this.isLoading2 = false;
                    this.indexUrlDialog = false;
                    this.$message.success('保存成功！');
                    this.newUrl='http://'+this.se_domain;
                }
            },
            get_se_domain($e){
                //console.log($e)
                for(var k in this.options){
                    var a=this.options[k];
                    if(a.id==$e){
                        this.se_domain=a.domain;
                        console.log(this.se_domain)
                        break;
                    }
                }
            }
        },
    }
</script>

<style scoped>
    .bc-box{
        width: calc(100% - 40px);
        height: calc(100% - 40px);
        padding: 20px;
    }
    .bc-box .bc-header{
        width: 100%;
        height: 40px;
    }
    .bc-box .bc-header .bc-title{
        display: inline-block;
        width: 120px;
        height: 40px;
        margin-right: 30px;
        font-size: 20px;
        line-height: 40px;
        vertical-align: top;
    }
    .bc-box .bc-header .bc-cont{
        display: inline-block;
        width: calc(100% - 150px);
        height: 100%;
        vertical-align: top;
    }
    .bc-box .bc-main{
        width: 100%;
        height: 885px;
        min-height: 755px;
        padding: 40px 110px;
    }
    .bc-box .bc-main .m-left,.bc-box .bc-main .m-right{
        display: inline-block;
        width: 360px;
        height: 100%;
        padding: 40px 0 180px 0;
        vertical-align: top;
        position: relative;
    }
    .bc-box .bc-main .m-mid{
        display: inline-block;
        width: 200px;
        height: 100%;
        padding: 40px 0 180px 0;
        vertical-align: top;
    }
    .bc-box .bc-main .m-mid .mid-btn-box{
        width: 100px;
        margin: 50px auto;
    }
    .m-left .tit,.m-right .tit{
        width: 100%;
        height: 30px;
        font-size: 16px;
        text-align: center;
        line-height: 30px;
        position: absolute;
        top: 0;
        left: 0;
    }
    .m-left .mid,.m-right .mid{
        width: 100%;
        height: 100%;
    }
    .m-left .mid textarea,.m-right .mid textarea{
        width: 100%;
        height: 100%;
        padding: 10px;
        border-radius: 4px;
        border: 1px solid #ccc;
        color: #333;
        line-height: 30px;
        resize: none;
        overflow-x: hidden;
        overflow-y: auto;
    }
    .m-left .bot,.m-right .bot{
        width: 100%;
        height: 180px;
        padding-top: 10px;
        position: absolute;
        left: 0;
        bottom: 0;
    }
    .m-left .bot .bot-btn,.m-right .bot .bot-btn{
        width: 100%;
        margin-bottom: 10px;
    }
    .m-left .bot .tips,.m-right .bot .tips{
        width: 100%;
        height: 130px;
        padding-left: 15px;
        line-height: 30px;
    }
    .m-left .bot .tips h5,.m-right .bot .tips h5{
        color: #333333;
    }
    .m-left .bot .tips .desc,.m-right .bot .tips .desc {
        color: #666666;
        font-size: 14px;
    }
    .mb-10{
        margin-bottom: 10px;
    }
</style>
